import { assoc, compose, includes, map, pick, prop } from 'ramda'

export const cleanRequest = item =>
  compose(
    pick(['id', 'name', 'userGroupIds', 'placeLevelIds', 'checklistTypeIds', 'assetIds']),
    assoc('userGroupIds', includes('all', item.userGroups) ? [] : map(prop('id'), item.userGroups)),
    assoc('checklistTypeIds', includes('all', item.checklistTypes) ? [] : map(prop('id'), item.checklistTypes)),
    assoc('placeLevelIds', includes('all', item.placeLevels) ? [] : map(prop('id'), item.placeLevels)),
    assoc('assetIds', includes('all', item.assets) ? [] : map(prop('id'), item.assets))
  )(item)
